import { Stack, StackProps, Box } from '@mui/system';
import { Types } from '@scorenco/core';

export enum SetsChoices {
  SETS_3_0 = '3_0',
  SETS_3_1 = '3_1',
  SETS_3_2 = '3_2',
  SETS_2_3 = '2_3',
  SETS_1_3 = '1_3',
  SETS_0_3 = '0_3',
}

type CompetitionRankingColumnSetsProps = StackProps & {
  ranking?: Types.Competitions_Ranking_Detail;
};

export const CompetitionRankingColumnSets = ({
  ranking,
  sx,
  ..._rest
}: CompetitionRankingColumnSetsProps) => {
  const extraColumns = ranking?.extra_columns as Record<string, number>;

  // Ordre d'affichage des sets (de la victoire la plus large à la défaite la plus large)
  const setsOrder = [
    SetsChoices.SETS_3_0,
    SetsChoices.SETS_3_1,
    SetsChoices.SETS_3_2,
    SetsChoices.SETS_2_3,
    SetsChoices.SETS_1_3,
    SetsChoices.SETS_0_3,
  ];

  // Mapping des sets vers leurs couleurs
  const setsColorMap: Record<
    SetsChoices,
    'win.main' | 'lost.main' | undefined
  > = {
    [SetsChoices.SETS_3_0]: 'win.main',
    [SetsChoices.SETS_3_1]: 'win.main',
    [SetsChoices.SETS_3_2]: undefined,
    [SetsChoices.SETS_2_3]: undefined,
    [SetsChoices.SETS_1_3]: 'lost.main',
    [SetsChoices.SETS_0_3]: 'lost.main',
  };

  return (
    <Stack
      direction="row"
      width="100%"
      justifyContent="center"
      alignItems="center"
      gap="0.1rem"
    >
      {setsOrder.flatMap((setChoice, index) => {
        const count = extraColumns?.[setChoice] ?? 0;
        const elements = [];

        // Ajouter le séparateur avant chaque élément sauf le premier
        if (index > 0) {
          elements.push(<Box key={`separator-${setChoice}`}>-</Box>);
        }

        // Ajouter l'élément principal
        const color = setsColorMap[setChoice];
        elements.push(
          <Box key={setChoice} sx={color ? { color } : undefined}>
            {count}
          </Box>
        );

        return elements;
      })}
    </Stack>
  );
};
